module.exports = __webpack_public_path__ + "img/card_vip.aeeeac13.jpg";